import { Link } from "react-router-dom";
import { Ticket, Sparkles, ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";

export default function WelcomePage() {
  return (
    <div data-testid="welcome-page">
      <div className="z-hero">
        <Logo to={null} size={36} className="" />
        <span className="z-hero-tagline">by ALO finances</span>
        <h1>L'événement,<br />réinventé.</h1>
        <p>Billetterie & invitations, cagnottes, e-votes & sondages, bons cadeaux et listes de cadeaux — organisez, participez et contribuez, sans complication.</p>
      </div>

      <div className="z-container" style={{ marginTop: -32 }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16 }}>
          <Link to="/register?role=buyer" className="z-role-card" data-testid="role-card-buyer">
            <div className="z-role-icon"><Ticket size={26} /></div>
            <h3>Je participe</h3>
            <p>Achetez vos billets, gérez vos invitations et profitez d'une expérience fluide.</p>
            <div style={{ marginTop: 16, color: "var(--z-orange)", fontWeight: 700, fontSize: 14, display: "flex", alignItems: "center", gap: 6 }}>
              Créer mon compte acheteur <ArrowRight size={16} />
            </div>
          </Link>

          <Link to="/register?role=organizer" className="z-role-card" data-testid="role-card-organizer">
            <div className="z-role-icon"><Sparkles size={26} /></div>
            <h3>J'organise</h3>
            <p>Créez vos événements, vendez vos billets et engagez votre communauté.</p>
            <div style={{ marginTop: 16, color: "var(--z-orange)", fontWeight: 700, fontSize: 14, display: "flex", alignItems: "center", gap: 6 }}>
              Créer mon compte organisateur <ArrowRight size={16} />
            </div>
          </Link>
        </div>

        <div style={{ textAlign: "center", marginTop: 32 }}>
          <Link to="/login" className="z-btn z-btn-outline" data-testid="welcome-login-btn">J'ai déjà un compte</Link>
        </div>

        <div style={{ textAlign: "center", marginTop: 18 }}>
          <Link to="/events" className="z-link" data-testid="welcome-guest-link" style={{ fontSize: 14 }}>
            Explorer sans compte →
          </Link>
        </div>

        <div style={{ marginTop: 48, textAlign: "center", color: "var(--z-muted)", fontSize: 13 }}>
          <Link to="/redeem" className="z-link" data-testid="welcome-redeem-link">J'ai un code d'invitation privé</Link>
        </div>
      </div>
    </div>
  );
}
